import React from "react";
import { get } from "react-hook-form";
import { validateINMobile } from "../../../utils/Utils";
import MyLabel from "./MyLabel";

const MyMobile = ({
  title,
  name,
  register,
  watch,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
  readOnly
}) => {
  const error = get(errors, name);

  return (
    <div className="form-group ">
      <MyLabel name={name} title={title} required={required}/>
      <div className="form-control-wrap">
        <input
        readOnly={readOnly}
          placeholder={placeholder || "Enter mobile number"}
          type="text"
          id={name}
         {...register(name, {
  required: required ? "Mobile number is required" : false,

  validate: (value) => {
    // ✅ Optional field → allow empty
    if (!required && !value) return true;

    // ✅ Required field empty → error
    if (required && !value) return false;

    // ✅ Validate only when value exists
    return (
      validateINMobile(value) ||
      "Enter a valid 10-digit Indian mobile number starting with 6-9"
    );
  },
})}

           className={`form-control ${error ? "is-invalid" : ""}`}
          value={watch(name)}
          onChange={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
            setValue(name, e.target.value, { shouldValidate: true });
            trigger(name);
          }}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
            e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
          }}
          disabled={disabled}
        />
        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyMobile;
